import Header from "./components/header/header";
import Main from "./components/main/main";

function App() {
  return (
    <>
      <Header />
      <Main />
    </>
  );
}

export default App;
